if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        if (this.form) {
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        const isCartPage = document.body.classList.contains("template-cart") || document.getElementById("main-cart-items");
        if (isCartPage) {
          this.cart = null;
        }
        this.submitButton = this.querySelector('[type="submit"]') || this.querySelector(".product-form__submit");
        if (document.querySelector("cart-drawer") && this.submitButton) this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
        this.syncDynamicCheckoutButton();
      }
      syncDynamicCheckoutButton() {
        if (!this.submitButton || !this.form) return;
        const dynamicCheckoutButton = this.form.querySelector(".shopify-payment-button__button");
        if (!dynamicCheckoutButton) return;
        if (this.submitButton.hasAttribute("disabled")) {
          dynamicCheckoutButton.setAttribute("disabled", "disabled");
          dynamicCheckoutButton.setAttribute("aria-disabled", "true");
        }
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            const msg = ((response == null ? void 0 : response.message) || (response == null ? void 0 : response.description) || "").toString().toLowerCase();
            const looksLikePartialAdd = msg.includes("only") && msg.includes("added") && msg.includes("cart");
            if (looksLikePartialAdd && this.cart) {
              const quickAddModal2 = this.closest("quick-add-modal");
              Promise.all([
                fetch(`${routes.cart_url}`).then((r) => r.text()),
                fetch(window.location.pathname).then((r) => r.text())
              ]).then(([cartHTML, pageHTML]) => {
                const cartDoc = new DOMParser().parseFromString(cartHTML, "text/html");
                const pageDoc = new DOMParser().parseFromString(pageHTML, "text/html");
                const cartSelectors = ["cart-drawer-items", ".drawer__footer"];
                for (const selector of cartSelectors) {
                  const targetElement = document.querySelector(selector);
                  const sourceElement = cartDoc.querySelector(selector);
                  if (targetElement && sourceElement) {
                    targetElement.replaceWith(sourceElement);
                  }
                }
                const iconSelectors = ["#cart-icon-bubble", "#cart-icon-bubble-sticky"];
                for (const selector of iconSelectors) {
                  const targetElement = document.querySelector(selector);
                  const sourceElement = pageDoc.querySelector(selector);
                  if (targetElement && sourceElement) {
                    targetElement.replaceWith(sourceElement);
                  }
                }
                this.cart.classList.remove("is-empty");
                if (typeof this.cart.open === "function") this.cart.open();
                if (quickAddModal2) {
                  quickAddModal2.hide(true);
                }
              }).catch((e) => console.error(e));
            } else {
              this.updateBlocksOnError();
            }
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response
            });
          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
        });
      }
      async updateBlocksOnError() {
        const response = await fetch(`${window.shopUrl}`);
        const text = await response.text();
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(text, "text/html");
        this.getSectionsToRender().forEach((section) => {
          let newContent;
          if (section.id) {
            newContent = newDocument.getElementById(section.id);
            const currentElement = document.getElementById(section.id);
            if (newContent && currentElement) {
              currentElement.innerHTML = newContent.innerHTML;
            }
          }
          if (section.selector) {
            newContent = newDocument.querySelector(section.selector);
            const currentElement = document.querySelector(section.selector);
            if (newContent && currentElement) {
              currentElement.innerHTML = newContent.innerHTML;
            }
            if (section.selector == "cart-drawer-items") currentElement == null ? void 0 : currentElement.classList.remove("is-empty");
          }
        });
      }
      getSectionsToRender() {
        return [
          {
            selector: "cart-drawer-items"
          },
          {
            selector: ".drawer__footer"
          },
          {
            id: "cart-icon-bubble"
          }
        ];
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
